module.exports = __webpack_public_path__ + "img/Severe.f35ae517.svg";